import { HomeContentBlocks } from "@app/layouts/Home/Elements/utils";
import { TeaserData } from "@app/types/ServerCustomContext";
import placeholders from "@pub/placeholders";
import {
  BreadCrumbs,
  ResponsiveImage,
  useCustomClassContext,
} from "@sphtech/dmg-design-system";
import cx from "classnames";

import styles from "./videooverlayportrait.module.css";

type Props = {
  content: HomeContentBlocks;
  itemWidth: number;
  itemHeight: number;
  setShowOverlay: (showOverlay: boolean) => void;
  setStageItem: (teaser: TeaserData) => void;
};

const Strip = ({
  content,
  itemWidth,
  itemHeight,
  setShowOverlay,
  setStageItem,
}: Props) => {
  const customClass = useCustomClassContext();

  return (
    <section className={styles.videoStrip}>
      {content.items.map((item, index) => {
        const croppedImage =
          item.image?.crops.original || placeholders.portrait;

        return (
          <button
            key={index}
            className={styles.videoLink}
            onClick={() => {
              setShowOverlay(true);
              setStageItem(item);
            }}
          >
            <div
              className={cx(styles.image, customClass?.videoOverlay?.playIcon)}
            >
              <ResponsiveImage
                {...croppedImage}
                srcWidth={itemWidth}
                srcHeight={itemHeight}
                fill="contain"
                loading="lazy"
              />
            </div>

            <div>
              <div className={styles.sectionLabel}>
                <BreadCrumbs sections={item.sections} />
              </div>
              <p className={styles.title}>{item.title}</p>
            </div>
          </button>
        );
      })}
    </section>
  );
};

export default Strip;
